<form (ngSubmit)="search()">
  <div class="form-grid filterPanel form-group">
    <div *ngIf="opened" class="">
      <p-checkbox
        name="assignedToMe"
        label="Assigned to me"
        binary="true"
        [(ngModel)]="state.filter.filters.assignedToMe.value"
        (onChange)="search()"
      ></p-checkbox>
    </div>

    <div *ngIf="opened" class="">
      <p-multiSelect
        name="customers"
        [options]="customers"
        [(ngModel)]="state.filter.filters.customerIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Customers"
      ></p-multiSelect>
    </div>

    <div *ngIf="opened" class="">
      <p-multiSelect
        name="suppliers"
        [options]="suppliers"
        [(ngModel)]="state.filter.filters.supplierIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Suppliers"
      ></p-multiSelect>
    </div>

    <div *ngIf="opened" class="">
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="state.filter.filters.regNo.value" />
        <label>Reg.No.</label>
      </span>
    </div>

    <div>
      <p-dropdown
        name="incidentTypes"
        [options]="incidentTypes"
        [(ngModel)]="state.filter.filters.incidentType.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        placeholder="Incident Types"
      ></p-dropdown>
    </div>

    <div class="" *ngIf="state.filter.filters.openedFrom">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.openedFrom.value"
          name="openedFrom"
          dateFormat="dd/mm/yy"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>Opened From</label>
      </span>
    </div>

    <div class="" *ngIf="state.filter.filters.openedTo">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.openedTo.value"
          name="openedTo"
          dateFormat="dd/mm/yy"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>Opened To</label>
      </span>
    </div>

    <div class="" *ngIf="state.filter.filters.closedFrom">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.closedFrom.value"
          name="closedFrom"
          dateFormat="dd/mm/yy"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>Closed From</label>
      </span>
    </div>

    <div class="" *ngIf="state.filter.filters.closedTo">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.closedTo.value"
          name="closedTo"
          dateFormat="dd/mm/yy"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>Closed To</label>
      </span>
    </div>

    <div class="" *ngIf="state.filter.filters.assignees">
      <p-multiSelect
        name="users"
        [options]="assignees"
        [(ngModel)]="state.filter.filters.assignees.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="Assignee(s)"
      ></p-multiSelect>
    </div>

    <div class="" *ngIf="state.filter.filters.completedFrom">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.completedFrom.value"
          name="fromCompletedDate"
          dateFormat="dd/mm/yy"
          id="fromCompletedDate"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>From Completed Date</label>
      </span>
    </div>

    <div class="" *ngIf="state.filter.filters.completedTo">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="state.filter.filters.completedTo.value"
          name="toCompletedDate"
          dateFormat="dd/mm/yy"
          id="toCompletedDate"
          [style]="{ width: '100%', 'max-width': '100%' }"
          [inputStyle]="{ width: 'calc(100% - 40px)' }"
        ></p-calendar>
        <label>To Completed Date</label>
      </span>
    </div>

    <div class="button-container">
      <button pButton type="submit" label="Search"></button>
      <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
      <!--            <button pButton type="button" label="Refresh" (click)="refresh()"></button>-->
    </div>
  </div>
</form>

<p-table
  #dt
  [value]="page.items"
  [totalRecords]="page.total"
  [lazy]="true"
  (onLazyLoad)="onGridLazyLoad($event)"
  [sortField]="state.filter.sortField"
  [sortOrder]="state.filter.sortOrder"
  [rows]="state.filter.rows"
  [first]="state.filter.first"
  [rowsPerPageOptions]="[10, 20, 50, 100]"
  [pageLinks]="8"
  [paginator]="true"
  [loading]="loading"
  [resizableColumns]="true"
  [responsive]="true"
  selectionMode="multiple"
  [(selection)]="selectedIncidents"
>
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn pSortableColumn="jobNumber">Job</th>
      <th pResizableColumn pSortableColumn="vehicleReg">Vehicle</th>
      <th pResizableColumn pSortableColumn="customerName">Customer</th>
      <th pResizableColumn pSortableColumn="supplierName">Supplier</th>
      <th pResizableColumn pSortableColumn="opened">Opened</th>
      <th *ngIf="!opened" pSortableColumn="closed">Closed</th>
      <th pResizableColumn pSortableColumn="assigneeName">Assignee</th>
      <th pResizableColumn pSortableColumn="latestPickupDate">Latest Pickup</th>
      <th pResizableColumn pSortableColumn="latestDropoffDate">Latest Dropoff</th>
      <th pResizableColumn pSortableColumn="typeName">Incident</th>
      <th *ngIf="!opened">Closure Reason</th>
      <th *ngIf="opened" pResizableColumn pSortableColumn="jobCompletedDate">Job Completed Date</th>
      <th *ngIf="opened" pSortableColumn="dueBy">Due By Date</th>
      <th *ngIf="opened">Action</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-index="index">
    <tr [pSelectableRow]="item" [class]="getRowStyle(item, index)">
      <td>
        <div [title]="item.jobNumber">
          <a *ngIf="item.jobNumber" [routerLink]="['/app/jobscreen', item.jobId]">{{
            item.jobNumber
          }}</a>
          <span *ngIf="!item.jobNumber">N/A</span>
        </div>
      </td>
      <td>
        <div [title]="item.vehicleReg">
          {{ item.vehicleReg }}
        </div>
      </td>
      <td>
        <div pTooltip="{{ item.customerName }}">
          {{ item.customerName }}
        </div>
      </td>
      <td>
        <div pTooltip="{{ item.supplierName }}">
          {{ item.supplierName }}
        </div>
      </td>
      <td>
        <div [title]="getDateLabel(item.opened)">
          {{ getDateLabel(item.opened) }}
        </div>
      </td>
      <td *ngIf="!opened">
        <div [title]="getDateDescription(item.closed)">
          {{ getDateDescription(item.closed) }}
        </div>
      </td>
      <td>
        <div [title]="item.assigneeName || 'Assign to me'">
          <ng-container *ngIf="opened; else assigneeNameRaw">
            <ng-container
              *ngIf="item.assigneeId; then assigneeAnchor; else assignToMeAnchor"
            ></ng-container>
            <ng-template #assigneeAnchor>
              <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">{{
                item.assigneeName
              }}</a>
            </ng-template>
            <ng-template #assignToMeAnchor>
              <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">Assign</a>
            </ng-template>
          </ng-container>
          <ng-template #assigneeNameRaw>{{ item.assigneeName }}</ng-template>
        </div>
      </td>
      <td>
        <div [title]="getPickupDescription(item)" [class.empty-value]="!getPickupDescription(item)">
          {{ getPickupDescription(item) || 'N/A' }}
        </div>
      </td>
      <td>
        <div
          [title]="getDropoffDescription(item)"
          [class.empty-value]="!getDropoffDescription(item)"
        >
          {{ getDropoffDescription(item) || 'N/A' }}
        </div>
      </td>
      <td>
        <div pTooltip="{{ item.comment }}" tooltipStyleClass="commentTooltip" tooltipPosition="top">
          {{ item.typeName || 'N/A' }}
        </div>
      </td>
      <td *ngIf="!opened">
        <div pTooltip="{{ item.closureReason?.reason || 'N/A' }}">
          {{ item.closureReason?.reason || 'N/A' }}
        </div>
      </td>
      <td *ngIf="opened">
        <div [title]="getDateLabel(item.jobCompletedDate)">
          {{ getDateLabel(item.jobCompletedDate) }}
        </div>
      </td>
      <td *ngIf="opened">
        <div [title]="getDateLabel(item.dueBy)">
          <span [style.color]="isOverdue(item.dueBy) ? 'red' : null">
            {{ getDateLabel(item.dueBy, true) }}
          </span>
        </div>
      </td>
      <td *ngIf="opened">
        <div style="display: flex; flex-direction: column; height: 100%; grid-gap: 5px">
          <a *ngIf="currentUserId == item.assigneeId" (click)="closeIncident(item)">Close</a>
          <a *ngIf="currentUserId == item.assigneeId" (click)="showAmendDueDateDialog(item)"
            >Amend Due By Date</a
          >
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!--- DATATABLES DEPRECATED --
<p-dataTabl #dt [value]="page.items" [totalRecords]="page.total"
             [lazy]="true" (onLazyLoad)="onGridLazyLoad($event)"
             [sortField]="state.filter.sortField" [sortOrder]="state.filter.sortOrder"
             [rows]="state.filter.rows" [first]="state.filter.first" [rowStyleClass]="getRowStyle"
             [rowsPerPageOptions]="[10,20,50,100]" [pageLinks]="8" [paginator]="true"
             [loading]="loading" [resizableColumns]="true" [responsive]="true" selectionMode="multiple" [(selection)]="selectedIncidents">

    <p-column field="jobNumber" header="Job" sort [sortable]="tru" [style]="{'width': '6%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="item.jobNumber">
                <a *ngIf="item.jobNumber" [routerLink]="['/app/jobscreen', item.jobId]">{{item.jobNumber}}</a>
                <span *ngIf="!item.jobNumber">N/A</span>
            </div>
        </ng-template>
    </p-column>
    <p-column field="vehicleReg" header="Vehicle" sort [sortable]="false" [style]="{'width': '5%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="item.vehicleReg">
                {{item.vehicleReg}}
            </div>
        </ng-template>
    </p-column>
    <p-column field="customerName" header="Customer" sort [sortable]="false" [style]="{'width': '5%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div pTooltip="{{item.customerName}}">
                {{ item.customerName }}
            </div>
        </ng-template>
    </p-column>
    <p-column field="supplierName" header="Supplier" sort [sortable]="false" [style]="{'width': '5%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div pTooltip="{{item.supplierName}}">
                {{ item.supplierName }}
            </div>
        </ng-template>
    </p-column>
    <p-column field="opened" header="Opened" [sortable]="tru" [style]="{'width': '6%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="getDateLabel(item.opened)">
                {{getDateLabel(item.opened)}}
            </div>
        </ng-template>
    </p-column>
    <p-column *ngIf="!opened" field="closed" header="Closed" [sortable]="tru" [style]="{'width': '6%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="getDateDescription(item.closed)">
                {{getDateDescription(item.closed)}}
            </div>
        </ng-template>
    </p-column>
    <p-column field="assigneeName" header="Assignee" [sortable]="tru" [style]="{'width': '7%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="item.assigneeName || 'Assign to me'">
                <ng-container *ngIf="opened; else assigneeNameRaw">
                    <ng-container *ngIf="item.assigneeId; then assigneeAnchor; else assignToMeAnchor"></ng-container>
                    <ng-template #assigneeAnchor>
                        <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">{{item.assigneeName}}</a>
                    </ng-template>
                    <ng-template #assignToMeAnchor>
                        <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">Assign</a>
                    </ng-template>
                </ng-container>
                <ng-template #assigneeNameRaw>{{item.assigneeName}}</ng-template>
            </div>
        </ng-template>
    </p-column>
    <p-column field="pickup" header="Latest Pickup" [sortable]="false" [style]="{'width': '8%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="getPickupDescription(item)" [class.empty-value]="!getPickupDescription(item)">
                {{getPickupDescription(item) || 'N/A'}}
            </div>
        </ng-template>
    </p-column>
    <p-column field="dropoff" header="Latest Dropoff" [sortable]="false" [style]="{'width': '8%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div [title]="getDropoffDescription(item)" [class.empty-value]="!getDropoffDescription(item)">
                {{getDropoffDescription(item) || 'N/A'}}
            </div>
        </ng-template>
    </p-column>
    <p-column field="typeName" header="Incident" [sortable]="tru" [style]="{'width': '14%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div pTooltip="{{item.comment}}" tooltipStyleClass='commentTooltip' tooltipPosition='top'>
                {{ item.typeName || 'N/A'}}
            </div>
        </ng-template>
    </p-column>
    <p-column *ngIf="!opened" field="closureReason" header="Closure Reason" [sortable]="false" [style]="{'width': '15%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <div pTooltip="{{ item.closureReason.reason || 'N/A' }}">
                {{item.closureReason.reason || 'N/A'}}
            </div>
        </ng-template>
    </p-column>
    <p-column *ngIf="opened" header="Action" [sortable]="false" [style]="{'width': '5%'}">
        <ng-template let-item="rowData" pTemplate="body">
            <a *ngIf="currentUserId == item.assigneeId" href="#" (click)="closeIncident(item);">Close</a>
        </ng-template>
    </p-column>
</p-dataTable>

--->

<div class="footerPanel ui-grid-row">
  <button
    pButton
    class="btn-to-right"
    type="button"
    (click)="groupCloseIncidents()"
    label="Group Close Selected Incidents"
  ></button>
  <button
    pButton
    class="btn-to-right"
    type="button"
    (click)="downloadToCSV()"
    label="Download to CSV"
  ></button>
</div>

<p-overlayPanel #assigneeSelectionPanel>
  <div class="ui-g">
    <div class="ui-g-12">
      <a (click)="confirmAssigneeSelection()" class="cursor-pointer">Assign to me</a>
    </div>
    <div class="ui-g-12">
      <a (click)="otherAssigneeSelection()" class="cursor-pointer">Assign to someone else</a>
    </div>
    <div class="ui-g-12">
      <a (click)="assigneeSelectionPanel.hide()" class="cursor-pointer">Cancel</a>
    </div>
  </div>
</p-overlayPanel>

<!--DIALOGS-->

<p-dialog
  header="Raise Custom Incident"
  [(visible)]="raiseIncidentDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="raiseIncidentForm" (ngSubmit)="raiseIncident()">
    <div class="ui-g">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Assignee</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            appendTo="body"
            placeholder="Select assignee..."
            formControlName="assigneeId"
            [options]="assignees"
            [autoDisplayFirst]="false"
            [autoWidth]="false"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Comment</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            formControlName="comment"
            pInputTextarea
            rows="5"
            placeholder="Comment..."
            style="width: 100%"
          ></textarea>
        </div>
      </div>

      <div class="ui-g-12">
        <button
          type="button"
          (click)="raiseIncidentDialog = false"
          pButton
          label="Close"
          class="btn-to-right"
        ></button>
        <button
          pButton
          type="submit"
          label="Raise Incident"
          [disabled]="raiseIncidentForm.invalid"
          class="green-btn btn-to-right"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Assign Incident"
  [(visible)]="assignIncidentDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="assignIncidentForm" (ngSubmit)="confirmOtherAssigneeSelection()">
    <div class="ui-g">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Assignee</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            placeholder="Select assignee..."
            formControlName="assigneeId"
            [options]="assignees"
            [autoDisplayFirst]="false"
            [autoWidth]="false"
            [filter]="true"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <button
          type="button"
          (click)="assignIncidentDialog = false"
          pButton
          label="Close"
          class="btn-to-right"
        ></button>
        <button
          pButton
          type="submit"
          label="Assign"
          [disabled]="assignIncidentForm.invalid"
          class="green-btn btn-to-right"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Close Incident"
  [(visible)]="closeIncidentDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px', height: '250px' }"
>
  <form [formGroup]="closeIncidentForm">
    <div class="ui-g" style="position: relative; height: 180px">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Reason</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            placeholder="Select closure reason..."
            formControlName="closureReasonId"
            [(ngModel)]="selectedClosureReasonId"
            [options]="closureReasons"
            [autoDisplayFirst]="false"
            [autoWidth]="false"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Notes</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            name="notes"
            pInputTextarea
            style="width: 100%"
            maxlength="1024"
            rows="4"
            formControlName="closureNotes"
          ></textarea>
        </div>
      </div>
      <div class="ui-g-12">
        <button
          type="button"
          pButton
          icon="fa fa-close"
          (click)="clearClosureVars()"
          label="Close"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          pButton
          icon="fa fa-check"
          label="Ok"
          (click)="confirmCloseIncident()"
          class="ui-button btn-to-right green-btn"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Amend Due By Date"
  [(visible)]="amendDueDateDialog"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '450px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="amendDueDateForm">
    <div class="ui-g" style="margin-bottom: 15px">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Due By</label>
        </div>
        <div class="ui-grid-col-8">
          <p-calendar
            formControlName="dueBy"
            placeholder="Select due by date..."
            dateFormat="dd/mm/yy"
            [minDate]="currentDate"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            appendTo="body"
          >
          </p-calendar>
        </div>
      </div>
    </div>
    <p-footer>
      <div style="text-align: right">
        <button
          pButton
          type="button"
          label="Cancel"
          class="ui-button ui-button-default"
          (click)="amendDueDateDialog = false"
        ></button>
        <button
          pButton
          type="button"
          label="Save"
          class="ui-button green-btn"
          [disabled]="!amendDueDateForm.valid"
          (click)="amendDueDate()"
        ></button>
      </div>
    </p-footer>
  </form>
</p-dialog>
